import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { forwardRef, memo } from "react";
import { ButtonBase } from "./ButtonBase";
import { ColorsProvider } from "../providers/ColorsProvider";
import { SlotsProvider } from "../providers/SlotsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
import { Typography } from "./Typography";
export const buttonClasses = {
    root: "MinervaButton-root",
    filled: "MinervaButton-filled",
    tonal: "MinervaButton-tonal",
    outlined: "MinervaButton-outlined",
    ghost: "MinervaButton-ghost",
    minimal: "MinervaButton-minimal",
    disabled: "MinervaButton-disabled",
};
export const buttonSlots = {
    label: Typography,
};
export const buttonVariants = ["filled", "tonal", "outlined", "ghost", "minimal"];
export const Button = memo(forwardRef((props, ref) => {
    const { variant = "filled", fullWidth, startNode, endNode, density = "comfortable", color = "surface", colorSet, invertColors, slots, slotProps, className, children, disabled, disableHoverEffect, disableActiveEffect, sx, ...rest } = useDefaultProps({ component: "Button", props });
    return (_jsx(SlotsProvider, { baseSlots: buttonSlots, slots: slots, children: ({ label: Label }) => (_jsx(ColorsProvider, { color: disabled ? "disabled" : color, colorSet: colorSet ? colorSet : variant === "tonal" ? "container" : "main", invertColors: invertColors
                ? invertColors
                : variant !== "filled" && variant !== "tonal", children: (colorStyles) => (_jsxs(ButtonBase, { ref: ref, disabled: disabled, className: clsx([
                    className,
                    buttonClasses.root,
                    variant && buttonClasses[variant],
                    disabled && buttonClasses.disabled,
                ]), disableHoverEffect: variant === "minimal" || disableHoverEffect, disableActiveEffect: variant === "minimal" || disableActiveEffect, sx: mergeSx({
                    ...colorStyles,
                    paddingY: density === "comfortable"
                        ? 3
                        : density === "dense"
                            ? 2
                            : 0,
                    paddingLeft: density === "comfortable"
                        ? startNode || (!children && endNode)
                            ? 3
                            : 4
                        : density === "dense"
                            ? startNode || (!children && endNode)
                                ? 2
                                : 3
                            : 0,
                    paddingRight: density === "comfortable"
                        ? endNode || (!children && startNode)
                            ? 3
                            : 4
                        : density === "dense"
                            ? endNode || (!children && startNode)
                                ? 2
                                : 3
                            : 0,
                    width: fullWidth ? "100%" : "fit-content",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: density === "none" ? 0 : density === "dense" ? 1 : 2,
                    borderRadius: (theme) => theme.radius.default,
                    [`&.${buttonClasses.outlined}`]: {
                        backgroundColor: "transparent",
                        boxShadow: (theme) => `inset 0 0 0 1px ${theme.palette.outline}`,
                        [`&.${buttonClasses.disabled}`]: {
                            backgroundColor: "transparent",
                        },
                    },
                    [`&.${buttonClasses.ghost}`]: {
                        backgroundColor: "transparent",
                        [`&.${buttonClasses.disabled}`]: {
                            backgroundColor: "transparent",
                        },
                    },
                    [`&.${buttonClasses.minimal}`]: {
                        backgroundColor: "transparent",
                        padding: 0,
                        gap: 0,
                        [`&.${buttonClasses.disabled}`]: {
                            backgroundColor: "transparent",
                        },
                    },
                    [`&.${buttonClasses.disabled}`]: {
                        ...colorStyles,
                    },
                }, sx), ...rest, children: [startNode, typeof children === "string" ? (_jsx(Label, { variant: "button", fontWeight: "semibold", ...slotProps?.label, children: children }, "button-label")) : (children), endNode] })) })) }));
}));
//# sourceMappingURL=Button.js.map